/**
 * @file 手动控制 highlight.js 的引入，控制包大小
 * @author wanzhongyun
 */

import highlight from 'highlight.js/lib/core';
import 'highlight.js/styles/github.css';

highlight.registerLanguage('c-like', require('highlight.js/lib/languages/c-like'));
highlight.registerLanguage('cpp', require('highlight.js/lib/languages/cpp'));
highlight.registerLanguage('css', require('highlight.js/lib/languages/css'));
highlight.registerLanguage('django', require('highlight.js/lib/languages/django'));
highlight.registerLanguage('htmlbars', require('highlight.js/lib/languages/htmlbars'));
highlight.registerLanguage('python', require('highlight.js/lib/languages/python'));
highlight.registerLanguage('shell', require('highlight.js/lib/languages/shell'));

export default highlight;
